'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cn } from '@repo/ui/lib'
import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from 'react'

const Tabs = TabsPrimitive.Root

const TabsList = forwardRef<
  ComponentRef<typeof TabsPrimitive.List>,
  ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    className={cn(
      'inline-flex items-center justify-center gap-2 border-b border-gray-100',
      className,
    )}
    ref={ref}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const tabsTriggerClassName = (className?: string) =>
  cn(
    'inline-flex items-center justify-center relative',
    'whitespace-nowrap text-sm font-medium text-gray-500 data-[state=active]:text-brand',
    'px-4 py-3 h-full',
    'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    'transition-all data-[disabled]:pointer-events-none',
    'data-[disabled]:opacity-50',
    `after:content-[''] after:transition-colors after:absolute after:-bottom-px after:w-full after:h-0.5`,
    'data-[state=active]:after:bg-brand',
    'hover:after:bg-gray-200 hover:text-gray-700',
    className,
  )

const TabsTrigger = forwardRef<
  ComponentRef<typeof TabsPrimitive.Trigger>,
  ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger className={tabsTriggerClassName(className)} ref={ref} {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = forwardRef<
  ComponentRef<typeof TabsPrimitive.Content>,
  ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    className={cn(
      'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      className,
    )}
    ref={ref}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsContent, TabsList, TabsTrigger, tabsTriggerClassName }
